import { httpClient } from "./client";
import { SuscripcionCampoAdicionalVista } from "../types/camposAdicionales";

export const HttpCamposAdicionales = {
    obtenerDeOrden: (): Promise<SuscripcionCampoAdicionalVista[]> =>
        httpClient.get("/tienda/suscripcion-campos-adicionales/orden"),
};
